import { render, staticRenderFns } from "./fibre.vue?vue&type=template&id=703db064&scoped=true&"
import script from "./fibre.vue?vue&type=script&lang=js&"
export * from "./fibre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703db064",
  null
  
)

export default component.exports